var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocUploadDlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 200,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 74,
    width: 112,
    height: 112,
    rx: 12,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.407 98.002c12.594-16.571 26.247-10.98 32.675-5.357 12.588-3.481 23.871 8.571 24.908 21.159 1.875 22.765-16.337 32.675-5.357 41.245 2.436 1.901 9.374 1.071 12.321-1.071 1.339 10.177-5.089 15.266-11.517 18.48-17.296 8.648-38.701 5.622-50.62 2.946-13.123-2.946-16.337-15.802-15.266-23.837 2.411 4.018 7.753 5.746 12.32 2.947 8.303-5.089-19.819-29.729.536-56.512Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.088 148.889c.179 2.5.054 7.981-1.875 9.91-.943.943-3.325 1.969-6.307 3.254-4.634 1.997-10.719 4.619-15.119 8.53-5.785 5.142-7.053 13.927-6.963 15.266h72.849c.089-1.339-1.179-10.124-6.964-15.266-4.399-3.911-10.485-6.533-15.119-8.53-2.982-1.285-5.363-2.311-6.307-3.254-1.928-1.929-2.053-7.41-1.875-9.91h-12.32Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.242 148.888h-6.155c.179 2.5.054 7.982-1.874 9.91-.944.944-3.325 1.97-6.308 3.255-2.048.883-4.38 1.888-6.725 3.072 1.131 2.246 2.739 4.504 4.725 5.993 3.214 2.411 12.052 2.947 16.337 2.947v-25.177Zm.001 0h6.165c-.179 2.5-.054 7.982 1.875 9.91.943.944 3.325 1.97 6.307 3.255 2.046.882 4.375 1.885 6.717 3.068-1.131 2.247-2.74 4.507-4.727 5.997-3.214 2.411-12.052 2.947-16.337 2.947v-25.177Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.031 133.712c-2.573 10.908-11.201 21.069-21.448 21.069-10.205 0-18.805-10.097-21.416-20.938a3.097 3.097 0 0 1-.546.048c-2.514 0-4.553-2.998-4.553-6.696 0-3.698 2.039-6.696 4.553-6.696.144 0 .286.01.426.029 2.459-11.104 11.169-19.312 21.536-19.312 10.403 0 19.136 8.264 21.561 19.425.302-.093.616-.142.937-.142 2.514 0 4.553 2.998 4.553 6.696 0 3.698-2.039 6.696-4.553 6.696-.362 0-.713-.062-1.05-.179Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.853 119.964c13.745-2.335 19.015-7.007 20.622-11.471.804 2.678 4.174 7.514 7.767 9.91 4.821 3.214 8.571 2.41 12.588 1.875 1.25-.893 2.089-4.018-1.339-10.446-4.285-8.035-12.588-9.106-24.64-10.177-9.642-.857-21.069 10.445-25.444 15.802-.357.714-3.749 6.917 10.446 4.507Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4B2CF",
    d: "M-3 0h327v50H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.055 31.144h3.412c.876 0 1.687-.148 2.433-.444a6.057 6.057 0 0 0 1.986-1.303 5.53 5.53 0 0 0 1.314-1.942c.317-.74.476-1.544.476-2.413 0-.87-.159-1.674-.476-2.414a5.998 5.998 0 0 0-1.314-1.97 6.055 6.055 0 0 0-1.986-1.303 6.2 6.2 0 0 0-2.433-.471h-3.412v12.26ZM37 34.723V15.305h7.523c1.473 0 2.834.25 4.083.75a9.788 9.788 0 0 1 3.272 2.052 9.594 9.594 0 0 1 2.181 3.107c.541 1.183.812 2.46.812 3.828 0 1.387-.262 2.663-.784 3.828a9.48 9.48 0 0 1-2.209 3.079A10.413 10.413 0 0 1 48.606 34c-1.25.481-2.61.722-4.083.722H37Zm22.045 0V15.305h9.565c1.324 0 2.489.259 3.496.777 1.025.5 1.818 1.202 2.377 2.108.578.906.867 1.951.867 3.134 0 1.24-.345 2.33-1.035 3.274-.69.943-1.613 1.646-2.769 2.108l4.335 8.017h-4.53l-3.832-7.434H63.1v7.434h-4.055ZM63.1 23.988h5.146c.914 0 1.641-.24 2.182-.722.56-.48.839-1.11.839-1.886 0-.777-.28-1.405-.84-1.886-.54-.481-1.267-.721-2.18-.721H63.1v5.215Zm16.325 10.735V15.305h4.055v19.418h-4.055Zm15.087 0-7.943-19.418h4.39l5.986 15.285 6.124-15.285h4.195L99.21 34.723h-4.698Zm15.812 0V15.305h15.046V18.8h-10.99v4.439h7.243v3.384h-7.243v4.604h11.102v3.496h-15.158Zm19.424 0V15.305h9.564c1.324 0 2.49.259 3.496.777 1.026.5 1.818 1.202 2.377 2.108.578.906.867 1.951.867 3.134 0 1.24-.345 2.33-1.034 3.274-.69.943-1.613 1.646-2.769 2.108l4.335 8.017h-4.531l-3.831-7.434h-4.419v7.434h-4.055Zm4.055-10.735h5.146c.913 0 1.641-.24 2.181-.722.56-.48.839-1.11.839-1.886 0-.777-.279-1.405-.839-1.886-.54-.481-1.268-.721-2.181-.721h-5.146v5.215Zm23.349 10.735V15.305h4.055v15.867h10.711v3.55h-14.766Zm18.959 0V15.305h4.055v19.418h-4.055Zm18.667.277c-1.455 0-2.816-.25-4.084-.749a10.569 10.569 0 0 1-3.328-2.136 10.213 10.213 0 0 1-2.209-3.162c-.522-1.22-.783-2.534-.783-3.94 0-1.423.261-2.736.783-3.938a9.915 9.915 0 0 1 2.237-3.19 10.25 10.25 0 0 1 3.3-2.108c1.268-.518 2.629-.777 4.084-.777a11.187 11.187 0 0 1 5.928 1.692 8.703 8.703 0 0 1 2.238 1.942l-2.741 2.69c-.708-.869-1.529-1.525-2.461-1.969a6.694 6.694 0 0 0-2.964-.666c-.877 0-1.697.167-2.462.5a5.846 5.846 0 0 0-1.985 1.331 5.94 5.94 0 0 0-1.315 1.997c-.317.759-.475 1.59-.475 2.497 0 .887.158 1.72.475 2.496a6.097 6.097 0 0 0 1.343 1.998 6.391 6.391 0 0 0 2.013 1.303 6.771 6.771 0 0 0 2.545.472 6.625 6.625 0 0 0 2.881-.638 7.253 7.253 0 0 0 2.377-1.83l2.657 2.607a9.176 9.176 0 0 1-2.209 1.914 11.21 11.21 0 0 1-2.797 1.248c-.988.277-2.004.416-3.048.416Zm11.823-.277V15.305h15.046V18.8h-10.991v4.439h7.243v3.384h-7.243v4.604h11.103v3.496h-15.158Zm19.424 0V15.305h3.859l9.732 12.538V15.305h3.804v19.418h-3.58l-9.984-12.982v12.982h-3.831Zm31.994.277c-1.455 0-2.816-.25-4.083-.749a10.557 10.557 0 0 1-3.328-2.136 10.2 10.2 0 0 1-2.21-3.162c-.522-1.22-.783-2.534-.783-3.94 0-1.423.261-2.736.783-3.938a9.902 9.902 0 0 1 2.238-3.19c.95-.906 2.05-1.609 3.3-2.108 1.267-.518 2.628-.777 4.083-.777a11.21 11.21 0 0 1 5.929 1.692 8.698 8.698 0 0 1 2.237 1.942l-2.741 2.69c-.708-.869-1.529-1.525-2.461-1.969a6.691 6.691 0 0 0-2.964-.666 6.09 6.09 0 0 0-2.461.5 5.84 5.84 0 0 0-1.986 1.331 5.937 5.937 0 0 0-1.314 1.997c-.317.759-.476 1.59-.476 2.497 0 .887.159 1.72.476 2.496a6.094 6.094 0 0 0 1.342 1.998 6.38 6.38 0 0 0 2.014 1.303 6.768 6.768 0 0 0 2.545.472 6.623 6.623 0 0 0 2.88-.638 7.253 7.253 0 0 0 2.377-1.83l2.657 2.607a9.176 9.176 0 0 1-2.209 1.914 11.21 11.21 0 0 1-2.797 1.248c-.988.277-2.004.416-3.048.416Zm11.823-.277V15.305h15.046V18.8h-10.991v4.439h7.244v3.384h-7.244v4.604H285v3.496h-15.158Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 156,
    width: 62,
    height: 30,
    rx: 8,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 156,
    width: 38,
    height: 30,
    rx: 8,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 156,
    width: 24,
    height: 30,
    rx: 8,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 74,
    width: 142,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 100,
    width: 87,
    height: 14,
    rx: 7,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 127,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 320,
    height: 199,
    rx: 11.5,
    stroke: "#D2D9E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 200,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUploadDlIcon);
export default __webpack_public_path__ + "static/media/doc-upload-dl-icon.477d391270c749a7899a24ce4cc51f0b.svg";
export { ForwardRef as ReactComponent };